export default __webpack_public_path__ + "static/media/connect.d2787139.png";